import React, { memo, useContext } from 'react'

import { SelectInput } from '../index'
import { constants } from '../../../constants'
import { LanguageContext } from '../../../context/LanguageContext'

const RepeatSettings = ({ repeatOption, RepeatOptionHandler, repeatError, isDisabled = false }) => {
    // Context
    const { strings } = useContext(LanguageContext)

    // Constants
    const { getRepeatList } = constants
    const repeatList = getRepeatList()

    return (
        <>
            <SelectInput
                label={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_REPEAT}
                options={repeatList.map(r => r.display)}
                onChange={RepeatOptionHandler}
                value={repeatList.find(r => r.repeat === repeatOption).display}
                error={repeatError}
                name={'repeat'} //Please don't change the name. because it helps us to updated state.
                disabled={isDisabled}
            />
        </>
    )
}

export default memo(
    RepeatSettings,
    (prevProps, nextProps) =>
        !(
            prevProps.repeatOption !== nextProps.repeatOption ||
            prevProps.repeatCounter !== nextProps.repeatCounter ||
            prevProps.repeatError !== nextProps.repeatError
        )
)
